import {PermissionGuardBase} from "./permissionGuardBase.service";
import {IGuardMixin} from "./mixins/IGuardMixin";
import {LoggedGuardMixin} from "./mixins/loggedGuardMixin";

export class LoggedInGuard extends PermissionGuardBase {
  protected guardMixins: IGuardMixin[] = [new LoggedGuardMixin(this.userService)];
}
